/* @flow */
import DeviceActions from 'actions/DeviceActions';
import DeviceStore from 'stores/DeviceStore';
import Columns2 from 'components/Columns2.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Legend from 'components/Legend.jsx';
import React from 'react';
import SettingsContainer from './SettingsContainer.jsx';
import UserEmailDevice from './UserEmailDevice.jsx';
import NewEmailDeviceForm from './NewEmailDeviceForm.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import './styles/UserEmailsForm.scss';

const UserEmailsForm = React.createClass({
  mixins: [
    linkStateWithStores([DeviceStore]),
  ],

  getInitialState() {
    return this.getStateFromStores();
  },

  componentWillMount() {
    DeviceActions.loadDevices();
  },

  getStateFromStores() {
    return {
      devices: DeviceStore.getDevices(),
    };
  },

  getDevices() {
    return this.state.devices.type('email')
      .sort((a, b) => {
        const verified = b.isVerified() - a.isVerified();
        if (verified !== 0) {
          return verified;
        } else {
          return a.id > b.id;
        }
      });
  },

  canRemoveEmail() {
    if (this.state.devices.type('email').length < 2) {
      // Cannot remove if it's the only one
      return false;
    }
    return true;
  },

  render() {
    return (
      <SettingsContainer className="UserEmailsForm">
        <Fieldset>
          <Legend>
            Email
            <p>
              Choose where you’d like to receive account and message notifications.
            </p>
          </Legend>
          {
            this.getDevices().map(d =>
              <UserEmailDevice
                key={d.id}
                device={d}
                btnDisabled={!this.canRemoveEmail()}
              />
            )
          }
          <Columns2>
            <NewEmailDeviceForm />
          </Columns2>
        </Fieldset>
      </SettingsContainer>
    );
  },
});

export default UserEmailsForm;



// WEBPACK FOOTER //
// ./src/settings/components/UserEmailsForm.jsx